import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_LOCALE } from 'constants/app';

type AppSliceTypes = {
  isOverlayLoader: boolean;
  locale: string;
};

const initialState: AppSliceTypes = {
  isOverlayLoader: false,
  locale: DEFAULT_LOCALE,
};

const app = createSlice({
  name: 'app',
  initialState,
  reducers: {
    startOverlayLoader: (state) => {
      state.isOverlayLoader = true;
    },
    stopOverlayLoader: (state) => {
      state.isOverlayLoader = false;
    },
    setLocale: (state, { payload }: PayloadAction<string>) => {
      state.locale = payload;
    },
  },
});

export const { startOverlayLoader, stopOverlayLoader, setLocale } = app.actions;

export default app.reducer;
